export default __webpack_public_path__ + "static/media/faq.0aaa1128.svg";